import { render, staticRenderFns } from "./OTags.vue?vue&type=template&id=5da0b7ee&scoped=true&"
import script from "./OTags.vue?vue&type=script&lang=js&"
export * from "./OTags.vue?vue&type=script&lang=js&"
import style0 from "./OTags.vue?vue&type=style&index=0&id=5da0b7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da0b7ee",
  null
  
)

export default component.exports